import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

const ImageGalleryDialog = ({ open, onClose, images, startIndex }) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex);

  // Update current index when startIndex changes (e.g., a new thumbnail is clicked)
  useEffect(() => {
    setCurrentIndex(startIndex);
  }, [startIndex]);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrevious = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  if (!images || images.length === 0) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent sx={{ p: 0, position: 'relative' }}>
        <Box
          component="img"
          src={images[currentIndex]}
          alt={`Gallery Image ${currentIndex + 1}`}
          sx={{
            width: '100%',
            height: 'auto',
            maxHeight: '90vh',
            objectFit: 'contain',
            borderRadius: 2,
            display: 'block',
          }}
        />

        {/* Navigation buttons */}
        {images.length > 1 && (
          <>
            <IconButton
              onClick={handlePrevious}
              sx={{
                position: 'absolute',
                left: { xs: 8, md: 16 },
                top: '50%',
                transform: 'translateY(-50%)',
                bgcolor: 'rgba(0, 0, 0, 0.4)',
                color: 'white',
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.6)',
                  transform: 'translateY(-50%) scale(1.1)',
                },
                transition: 'transform 0.2s ease-in-out',
              }}
            >
              <ChevronLeft size={18} />
            </IconButton>
            <IconButton
              onClick={handleNext}
              sx={{
                position: 'absolute',
                right: { xs: 8, md: 16 },
                top: '50%',
                transform: 'translateY(-50%)',
                bgcolor: 'rgba(0, 0, 0, 0.4)',
                color: 'white',
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.6)',
                  transform: 'translateY(-50%) scale(1.1)',
                },
                transition: 'transform 0.2s ease-in-out',
              }}
            >
              <ChevronRight size={18} />
            </IconButton>
          </>
        )}

        {/* Close button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: { xs: 8, md: 16 },
            right: { xs: 8, md: 16 },
            bgcolor: 'rgba(0, 0, 0, 0.4)',
            color: 'white',
            '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.6)' },
          }}
        >
          <X size={20} />
        </IconButton>
      </DialogContent>
    </Dialog>
  );
};

export default ImageGalleryDialog;